import { useEffect, useState } from "react";
import "../styles/header.css";
import logo from "./logomain.png";
import { useIdleTimer } from "react-idle-timer";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

const Header = (props) => {
  const [state, setState] = useState("Active");
  const [count, setCount] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [showInfo, setShowInfo] = useState(false);

  const onIdle = () => {
    setState("Idle");
    setShowInfo(true);
    MySwal.fire({
      icon: "info",
      title: "Nastąpi",
      text: "wylogowanie, przekroczono czas bezczynności",
    }).then((result) => {
      window.location.reload(false);
    });
  };

  const onActive = () => {
    setState("Active");
  };

  const onAction = () => {
    setCount(count + 1);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: 60000 * 60 * 4,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (!showInfo) {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }
    }, 500);
    return () => {
      clearInterval(interval);
    };
  });

  return (
    <>
      <div className="mainContainerHeader">
        <div className="flexContainerHeader">
          <button className="colHeader_1">
            <img
              className="logoHeader"
              src={
                "https://ftpeople.pl/wp-content/uploads/2023/06/logomain.png"
              }
              alt="calendar"
              onClick={props.handleOptionChange}
            />
          </button>
          <div className="colHeader_2">
            <div>SYSTEM WSPARCIA OPERACYJNEGO - WOKANDA</div>
            <div className="flexHeader">
              <div className="flexHeader_col1">{props.user.name}</div>{" "}
              <div className="flexHeader_col2">
                <button
                  className="acceptButton"
                  onClick={() => window.location.reload(false)}
                >
                  WYLOGUJ
                </button>
              </div>
            </div>
          </div>
        </div>
        {props.allowedTeam.length > 1 &&
        props.user.role !== "consultantTele" &&
        props.user.role !== "consultantTeleSKD" ? (
          <div className="teamChangeBox">
            <div id="headerSelectBox" className="inputCol_3">
              <select
                type="text"
                id="teamSelect"
                name="form"
                value={props.team}
                onChange={props.handleTeamChange}
              >
                <option key="1" value="1">
                  Zespół 1
                </option>
                <option key="2" value="2">
                  Zespół 2
                </option>
                {props.user.bothTeam === "1" ? (
                  <option key="0" value="0">
                    Wszystkie zespoły
                  </option>
                ) : (
                  ""
                )}
              </select>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Header;
